// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"20096224","453":"3fbd52d6"}[chunkId] + ".chunk.js";
};